import "@crystal/core";
import "react";
import "../state/reducers.js";
import "../state/actions.js";
import "../state/utils.js";
import "../store/storage/memory-storage.js";
import "mitt";
import "../store/storage/universal-memory-storage.js";
import "@reduxjs/toolkit";
import "../store/state/host.js";
import "../store/state/modal.js";
import { getRuntimeInfo } from "../integration/state-getters.js";
import "../api/email-detection.js";
import "@account/configs";
import "@crystal/glass-bridge";
import "@crystal/http";
import "@crystal/recaptcha";
import "@crystal/analytics";
import "../ap2/config.js";
import "../ap2/state.js";
import { externalAuthConfig } from "./config.js";
import { saveAuthFlow } from "./persistence.js";
import { getRedirectUrl } from "./utils.js";
import "../config/source-ids.js";
import "../config/presets.js";
import { getUniversalAuthParams } from "../config/universal-auth.js";
const createKmcStarter = (flow, context) => ({
  startAuthFlow() {
    const config = externalAuthConfig.evaluateWithContext(context);
    saveAuthFlow(flow);
    const redirectUrl = getRedirectUrl(flow.method, context, getRuntimeInfo().isAuthProvider);
    const kmcAuthUrl = getKmcAuthUrl(flow, config, redirectUrl);
    window.location.assign(kmcAuthUrl);
  }
});
function getKmcAuthUrl({ provider, authContext, transitData }, { externalAuthServer, clientId, persistentClientId, providers }, redirectUrl) {
  let _clientId = authContext.persistentLogin ? persistentClientId : clientId;
  if (getRuntimeInfo().isAuthProvider) {
    _clientId = (transitData == null ? void 0 : transitData.clientId) || getUniversalAuthParams().clientId;
  }
  const adapterId = providers[provider].adapter;
  const url = new URL(`${externalAuthServer}/as/authorization.oauth2`);
  url.searchParams.set("client_id", _clientId);
  url.searchParams.set("pfidpadapterid", adapterId);
  url.searchParams.set("redirect_uri", redirectUrl);
  url.searchParams.set("response_type", "code");
  url.searchParams.set("access_token_manager_id", "jwtKmc");
  return url.href;
}
export {
  createKmcStarter,
  getKmcAuthUrl
};
//# sourceMappingURL=kmc.js.map
